import { FactorTypeName } from "../types";

export const factorTypeToString = (type: FactorTypeName): string => {
  switch (type) {
    case "received":
      return "دریافتی";
    case "spent":
      return "خرج شده";
    default:
      return "unknown factor type";
  }
};
